export default __webpack_public_path__ + "static/media/videos.e6a3c09e.svg";